import { Icons as icons } from '@blueprint/ui';
import { Maybe, Feature } from 'graphql.generated';

export type ListingFeature = {
    iconId: 'bed' | 'bath' | 'chair';
    content: number;
};

const getListingFeatures = (
    features: Maybe<Feature>[] | null | undefined
): ListingFeature[] => {
    return (
        features
            ?.filter((feature) => feature?.content)
            .map((feature) => {
                const iconId: keyof typeof icons =
                    feature?.iconId === 'bed'
                        ? 'bed'
                        : feature?.iconId === 'bath'
                        ? 'bath'
                        : 'chair';
                return { iconId, content: feature?.content || 0 };
            }) || []
    );
};
export default getListingFeatures;
